<ng-container *ngIf="isAllowedRegion; else regionError">
  <app-loading></app-loading>
  <app-screensaver></app-screensaver>
  <router-outlet></router-outlet>
</ng-container>
<ng-template #regionError>
  <app-error-region></app-error-region>
</ng-template>
<div id="connection" class="index-dialog connection-dialog" *ngIf="status === 'OFFLINE'">
  <div class="connection">
    <div class="error-dialog-box">
      <p class="error-dialog-box-message">You have low internet connection, please try again later.</p>
      <div class="error-dialog-box-buttons horizontal-focusable-container" data-blocked>
        <button id="exitButton" onclick="appExit()" class="button-exit primary-button focusable-element"
          type="button">Exit</button>
      </div>
    </div>
  </div>
</div>